export enum ModalMode {
  SUBMIT = 'submit',
  VIEW = 'view',
  PAST_DECISIONS = 'past-decisions',
}
